import { __assign } from "tslib";
import React, { createContext, useContext } from 'react';
import { cnData } from './langData';
export * from './langData';
var defaultContextValue = {
    prefix: 'icecream',
    langData: cnData
};
var configContext = createContext(defaultContextValue);
export function useConfig() {
    return useContext(configContext);
}
export function usePrefix(name, customizedPrefix) {
    var config = useConfig();
    if (customizedPrefix != null) {
        return customizedPrefix;
    }
    return config.prefix + '-' + name;
}
export function useLangData(moduleName) {
    var langData = useConfig().langData;
    if (moduleName) {
        return langData[moduleName];
    }
    return langData;
}
export default function ConfigProvider(props) {
    var prefix = props.prefix, langData = props.langData, children = props.children;
    return (React.createElement(configContext.Provider, { value: { prefix: prefix, langData: langData } }, children));
}
ConfigProvider.defaultProps = __assign({}, defaultContextValue);
//# sourceMappingURL=index.js.map